import { ArrowUpRight, MapPin } from "lucide-react";
import { PORTFOLIO } from "@/lib/mock";

export default function Portfolio() {
  return (
    <section
      id="portfolio"
      data-testid="portfolio-section"
      className="py-16 lg:py-24 bg-white"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14 lg:mb-20">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 text-xs font-semibold text-orange-600 mb-4">
              <span className="w-1.5 h-1.5 bg-orange-500 rounded-full" />
              RECENT PROJECTS
            </div>
            <h2 className="font-display font-semibold text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-[-0.025em] text-stone-900">
              Work that lasts longer
              <br />
              <span className="text-stone-500">than the warranty.</span>
            </h2>
          </div>
          <p className="text-stone-600 leading-relaxed md:max-w-sm md:text-right">
            A few recent installations across Greater St. Louis. Each project
            is one-of-one.
          </p>
        </div>

        {/* Magazine layout: alternating rows, large images */}
        <div className="space-y-16 lg:space-y-20">
          {PORTFOLIO.map((p, i) => (
            <a
              key={p.title}
              href="#contact"
              data-testid={`portfolio-item-${i}`}
              className="group grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-12 items-center"
            >
              <div
                className={`lg:col-span-8 ${i % 2 === 1 ? "lg:order-2" : ""}`}
              >
                <div className="relative aspect-[16/10] lg:aspect-[16/9] overflow-hidden rounded-3xl bg-stone-200">
                  <img
                    src={p.image}
                    alt={p.title}
                    loading="lazy"
                    className="absolute inset-0 h-full w-full object-cover transition-transform duration-[2000ms] ease-out group-hover:scale-105"
                  />
                  <div className="absolute top-5 left-5 bg-white/95 backdrop-blur-md rounded-full px-3.5 py-1.5 text-[10px] font-bold text-stone-900 tracking-wider uppercase">
                    Project · 0{i + 1}
                  </div>
                </div>
              </div>

              <div
                className={`lg:col-span-4 ${
                  i % 2 === 1 ? "lg:order-1 lg:pr-4" : "lg:pl-4"
                }`}
              >
                <div className="inline-flex items-center gap-1.5 text-xs font-semibold text-orange-600 mb-3">
                  <MapPin size={12} strokeWidth={2.5} />
                  {p.type}
                </div>
                <h3 className="font-display font-semibold text-3xl lg:text-4xl text-stone-900 leading-tight tracking-tight">
                  {p.title}
                </h3>
                <div className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-stone-900 group/cta">
                  View this project
                  <ArrowUpRight
                    size={18}
                    className="text-orange-600 transition-transform duration-300 group-hover/cta:translate-x-1 group-hover/cta:-translate-y-1"
                  />
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
